module.exports = __webpack_public_path__ + "static/media/Gabon.661a3cfe.png";